import axios from 'axios'
import { SearchObjectDanhSachPhieu } from '../models/VienPhiInfoModels';
import { urlParamsConfig } from '../../utils/ParamsUtils';
import { IInPhieuParams } from '../../models/params';
import { APP_CONFIGURATION_KEYS, SEARCH_OBJECT_MAX_SIZE } from '../../utils/Constant';
import { localStorageItem } from '../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { OctResponse } from '../../models/OctResponse';
const BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;

const API_PATH_CATEGORY = (localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.ADMIN_URL] || process.env.REACT_APP_ADMIN_API_URL) + "/simple-categories";

export const getListPatient = (searchObject: any) => {
  let url = BASE_URL + `/payment/search`
  return axios.get(urlParamsConfig(url, searchObject));
}

export const getStatusVienPhi = (searchObject: any) => {
  let url = BASE_URL + `/payment/status-summary`
  return axios.get(urlParamsConfig(url, searchObject));
}

export const getThongTinChiPhi= (searchObject: any) => {
  let url = BASE_URL + `/patients/ongoing-visit`
  return axios.get(urlParamsConfig(url, searchObject));
}

export const getDanhSachLoaiPhieuService = (searchObject: any) => {
  let url = API_PATH_CATEGORY + `/search`
  return axios.get(urlParamsConfig(url, searchObject));
}

export const getDanhSachHinhThucService = (searchObject: any) => {
  let url = API_PATH_CATEGORY + `/search`
  return axios.get(urlParamsConfig(url, searchObject));
}
export const getDanhSachPhieuService = (searchObject: SearchObjectDanhSachPhieu) => {
  let url = BASE_URL + `/invoices/search`
  return axios.get(urlParamsConfig(url, searchObject));
}

export const createInvoices = (data: any) => {
  var url = BASE_URL + '/invoices'
  return axios.post(url, data)
}

export const updateInvoices = (id: string, data: any) => {
  var url = BASE_URL + `/invoices/${id}`
  return axios.put(url, data)
}

export const updateDiscount = (data: any) => {
  var url = BASE_URL + '/order-data/update-discount'
  return axios.put(url, data)
}

export const getInvoiceByIdService = (id: string) => {
  let url = BASE_URL + `/invoices/${id}`
  return axios.get(url);
}

export const getDanhSachDichVu = (searchObject: any) => {
  let url = BASE_URL + `/order-data/by-visit`
  return axios.get(urlParamsConfig(url, searchObject));
}

export const cancelInvoices = (data: any) => {
  var url = BASE_URL + `/invoices/${data?.id}/cancel`
  return axios.post(url, data?.payload)
}

export const inPhieuVienPhi = async(params: IInPhieuParams) => {
  return await axios.post<Blob>(
    `${BASE_URL}/export/invoices`,
    params, 
    {
      responseType: 'blob',
    }
  );
};

export const inPhieuVienPhiDichVu = async (params: IInPhieuParams) => {
  return await axios.post<Blob>(
    `${BASE_URL}/export/invoices/orders`,
    params,
    {
      responseType: 'blob',
    }
  );
};

export const inPhieuVienPhiPhoi = async (params: IInPhieuParams) => {
  return await axios.post<Blob>(
    `${BASE_URL}/export/invoices/pre-receipt`,
    params,
    {
      responseType: 'blob',
    }
  );
};

export const getStatusPatient = (visitId: string) => {
  let url = BASE_URL + `/payment/visit-status?visitId=${visitId}`;
  return axios.get(url);
}

export const generateCodePayment = (code: string) => {
  let url = BASE_URL + `/invoices/next-code/${code}`;
  return axios.get(url);
};

export const getDsPhieuThu = (params: any) => {
  let url = BASE_URL + `/invoices/tree-list`;
  return axios.get(url, { params });
};

// chốt số liệu phiếu thu
export const getDsSoLieuPhieuThu = (params: any) => {
  let url = BASE_URL + `/invoices/finalized`;
  return axios.get(url, { params });
};

export const saveDsSoLieuPhieuThu = (data: any) => {
  let url = BASE_URL + `/invoices/finalized`;
  return axios.post(url, data);
};

export const cancelChotSoLieuPhieuThu = (id: string) => {
  let url = BASE_URL + `/invoices/${id}/revoke-finalized`;
  return axios.post(url);
};

// used VP + KB
export const getPaymentDetail = (visitId: string) => {
  let url = BASE_URL + `/payment/detail?visitId=${visitId}`;
  return axios.get(url);
}

export const paymentApproval = (data: any) => {
  var url = BASE_URL + `/payment/approve`;
  return axios.post(url, data)
}

export const paymentCancelApproval = (data: any) => {
  var url = BASE_URL + `/payment/cancel`;
  return axios.post(url, data)
}

// sổ thu
export const getDsSoThuTien = (searchObject: any) => {
  let url = BASE_URL + `/ledgers/search`;
  return axios.get(url, { params: searchObject });
}

export const createSoThuTien = (data: any) => {
  let url = BASE_URL + `/ledgers`;
  return axios.post(url, data);
}

export const updateSoThuTien = (data: any, id: string) => {
  let url = BASE_URL + `/ledgers/${id}`;
  return axios.put(url, data);
}

export const getDsChonSoThuTien = () => {
  let url = BASE_URL + `/ledgers/selection`;
  return axios.get(url, { params: SEARCH_OBJECT_MAX_SIZE });
}

export const saveChonSoThuTien = (data: any) => {
  let url = BASE_URL + `/ledgers/selection`;
  return axios.post(url, data);
}

export const getThongTinSoThuTien = (id: string) => {
  let url = BASE_URL + `/ledgers/${id}`;
  return axios.get(url);
}

export const getFormFieldConfig = (codes: string) => {
  let url = BASE_URL + `/wf-org-conf/get-by-list-code?codes=${codes}`;
  return axios.get(url);
}

export const changeOwnExpenses = async (params: { orderId: string; isOwnExpenses: boolean }) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/order-data/change-own-expenses`,
		params
	);

	return data;
};

/**
 * Change own expenses for a single order (returns updated OrderData)
 * Use this instead of changeOwnExpenses for single-row updates
 */
export const changeOwnExpensesSingle = async (params: { orderId: string; isOwnExpenses: boolean }) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/order-data/change-own-expenses-single`,
		params
	);

	return data;
};

export const changePaymentPercent = async (params: {
	id: string;
	type: 'TT' | 'BH';
	percent: number;
}) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/order-data/change-payment-percent`,
		params
	);

	return data;
};

/**
 * Change payment percent for a single order (returns updated OrderData)
 * Use this instead of changePaymentPercent for single-row updates
 */
export const changePaymentPercentSingle = async (params: {
	id: string;
	type: 'TT' | 'BH';
	percent: number;
}) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/order-data/change-payment-percent-single`,
		params
	);

	return data;
};
/**
 * Get GL (General Ledger) entries for a visit
 * Returns all accounting journal entries with details
 */
export const getGlEntriesByVisit = async (visitId: string) => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/gl-entry/visit/${visitId}`
	);

	return data;
};

/**
 * Get GL Account Mapping Rules
 * Returns mapping configuration from entry type to debit/credit accounts
 */
/**
 * Get all GL Account Mapping Rules
 */
export const getGlAccountMappingRules = async () => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule`
	);
	return data;
};

/**
 * Get GL Account Mapping Rule by ID
 */
export const getGlAccountMappingRuleById = async (id: number) => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule/${id}`
	);
	return data;
};

/**
 * Create new GL Account Mapping Rule
 */
export const createGlAccountMappingRule = async (rule: any) => {
	const { data } = await axios.post<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule`,
		rule
	);
	return data;
};

/**
 * Update GL Account Mapping Rule
 */
export const updateGlAccountMappingRule = async (id: number, rule: any) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule/${id}`,
		rule
	);
	return data;
};

/**
 * Delete GL Account Mapping Rule
 */
export const deleteGlAccountMappingRule = async (id: number) => {
	const { data} = await axios.delete<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule/${id}`
	);
	return data;
};

/**
 * Toggle GL Account Mapping Rule active status
 */
export const toggleGlAccountMappingRuleActive = async (id: number, isActive: boolean) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule/${id}/active?isActive=${isActive}`
	);
	return data;
};

/**
 * Get all GL Accounts (Chart of Accounts)
 * Returns active GL accounts from gl_account table
 */
export const getGlAccounts = async () => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/gl-account-mapping-rule/gl-accounts`
	);
	return data;
};

/**
 * Get GL Formula Configurations
 * Returns formulas for calculating financial indicators (ttBenhNhan, ttConNo, ttConDu)
 */
export const getGlFormulaConfigs = async () => {
	const { data } = await axios.get<OctResponse<any>>(
		`${BASE_URL}/gl-formula-config`
	);
	return data;
};

/**
 * Save GL Formula Configurations
 */
export const saveGlFormulaConfigs = async (configs: any[]) => {
	const { data } = await axios.put<OctResponse<any>>(
		`${BASE_URL}/gl-formula-config`,
		configs
	);
	return data;
};

export const updateInvoicesDate = (id: string, fields: Record<string, any>) => {
  let url = `${BASE_URL}/invoices/${id}/inv-date`;
  return axios.put(url, fields);
};

export const updateInvoicesFields = (id: string, fields: Record<string, any>) => {
  let url = `${BASE_URL}/invoices/${id}/update-fields`;
  return axios.put(url, fields);
};